/* @flow */
import React from 'react';
// $FlowIgnore
import { FaTrash } from 'react-icons/fa';

export default function TrashIcon({
  style
}: Object): React.Element {
  return <FaTrash style={style} />;
}